import { render, staticRenderFns } from "./demonTb.vue?vue&type=template&id=0278c4b0&scoped=true"
import script from "./demonTb.vue?vue&type=script&lang=js"
export * from "./demonTb.vue?vue&type=script&lang=js"
import style0 from "./demonTb.vue?vue&type=style&index=0&id=0278c4b0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278c4b0",
  null
  
)

export default component.exports